import { NgModule, Injector, Provider, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpModule, JsonpModule, Http, ConnectionBackend, Request, RequestOptions, RequestOptionsArgs, Response, XHRBackend, Headers } from '@angular/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileSelectDirective } from 'ng2-file-upload';
import { AdminComponent }  from './admin.component';
import { AdminNavigationComponent }  from './admin.navigation.component';
import { FirmwareComponent } from './firmware/admin.firmware.component'; 
import { FirmwareListComponent }  from './firmware/admin.firmware.list.component';
import { FirmwareUploadComponent }  from './firmware/admin.firmware.upload.component';
import { DeviceTypeComponent }  from './devicetype/admin.devicetype.component';
import { DeviceTypeAddComponent }  from './devicetype/admin.devicetype.add.component';
import { DeviceTypeListComponent }  from './devicetype/admin.devicetype.list.component';
import { TestGroupComponent } from './testgroup/admin.testgroup.component';
import { TestGroupListComponent }  from './testgroup/admin.testgroup.list.component';
import { TestGroupAddComponent }  from './testgroup/admin.testgroup.add.component';
import { Configuration } from '../app.constants';
import { adminRouting, appRoutingProviders } from './admin.routes';
//import { HttpModule, JsonpModule } from '@angular/http';
//import { AdalModule, provideAdalAuth } from '../services/adal.http.service';
import { AdalHttp } from '../services/adal.http.service';
import { EventHttpService } from '../services/event.http.service';
//import { AdConfigService } from '../services/adconfig.service';
import { AdalService } from '../adal/adal.service';
import { AppSettingsService } from '../services/appsettings.service';
import { CanActivateViaAuthGuard } from '../services/authguard.service';

//import { ProgressBarComponent } from '../common/progressbar/progressbar.component'
//import { ProgressBarService } from '../services/progressbar.service'
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';

import { ModalModule } from "../common/dialog";
import { SimpleNotificationsModule, NotificationsService } from 'angular2-notifications';
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { AuthHttp } from "../services/adal-async-http.service";
import { UiOverlayComponent } from "../common/uioverlay/ui-overlay.service";
import { BusyModule, BusyConfig } from 'angular2-busy';
import { PopoverModule } from 'ng2-bootstrap';
import { EmailUsername } from '../common/emailusername.pipe';
import { RippleComponent } from '../common/ripple.component';
import { ScrollbarDirective } from "../common/scrollbar/scrollbar.directive";
//import { PolymerElement } from '@vaadin/angular2-polymer';


@NgModule({
    imports: [
        adminRouting,
        HttpModule,
        JsonpModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule,
        SimpleNotificationsModule,
        DataTableModule,
        BusyModule.forRoot(
            new BusyConfig({
                message: '',
                template: `
                    <div class='text-center'>
    <div class='preloader4'></div>
<div>{{message}}</div>
</div>
                    
                `,
                backdrop: true,
                delay: 200,
                minDuration: 600
            })
        ),
        PopoverModule.forRoot()
        //FileUploadModule
        //AppSettingsModule,
        //AdalModule.withConfig(),//new AdalService(), new AdConfigService().adalConfig
        //AdConfigModule.withConfig()
        //.withConfig()
    ],

    declarations: [AdminComponent, AdminNavigationComponent, FirmwareComponent, FirmwareListComponent, FirmwareUploadComponent,
        DeviceTypeComponent, DeviceTypeAddComponent, DeviceTypeListComponent, TestGroupComponent, TestGroupListComponent,
        TestGroupAddComponent, FileSelectDirective, UiOverlayComponent, EmailUsername, RippleComponent, ScrollbarDirective],//, PolymerElement('vaadin-grid')],

    exports: [RippleComponent],
    //exports: [AdminComponent, AdminNavigationComponent, FirmwareComponent, FirmwareListComponent, FirmwareUploadComponent,
    //    DeviceTypeComponent, DeviceTypeAddComponent, DeviceTypeListComponent, TestGroupComponent, FileSelectDirective],

    providers: [
        appRoutingProviders,
        Configuration,
        //provideAdalConfig()
        //AdConfigService
        //{ provide: AdConfigService, useFactory: (http: Http) => { new AdConfigService(http) }, deps: [Http] },
        //provideAdalAuth()
        //provideAppSettingsConfig(),
        
,
        //AdConfig,
        //AppSettingsService,
        //AdalService,
        CanActivateViaAuthGuard,
        //NotificationsService,
        //AdConfigService,
        //AzureAdConfig,
        //provideAdalAuth()
        //new Provider(APP_INITIALIZER, useFactory: (settings: AppSettingsService) => () => settings.getAppSettings, deps: [AppSettingsService, Http], multi: true)
        //provideAdalConfig()

        //AppSettingsService,
        //{ provide: APP_INITIALIZER, useFactory: (settings: AppSettingsService) => () => { settings.getAppSettings() }, deps: [AppSettingsService], multi: true },

        {
            provide: AdalHttp, useFactory: (connectionBackend: XHRBackend, defaultOptions: RequestOptions, authService: AdalService, adConfigService: AppSettingsService, progressBarService: SlimLoadingBarService, notificationService: NotificationsService) => {
                return new AdalHttp(connectionBackend, defaultOptions, authService, adConfigService, progressBarService, notificationService);
            }, deps: [XHRBackend, RequestOptions, AdalService, AppSettingsService, SlimLoadingBarService, NotificationsService]
        },

        {
            provide: EventHttpService, 
            useFactory: (xhrBackend: XHRBackend, defaultOptions: RequestOptions, slimLoadingBarService: SlimLoadingBarService) => new EventHttpService(xhrBackend, defaultOptions, slimLoadingBarService) ,
            deps: [XHRBackend, RequestOptions, SlimLoadingBarService]
        },

        {
            provide: AuthHttp,
            useFactory: (http: Http) => new AuthHttp(http),
            deps: [Http]
        }
        
    ],
    //{ provide: APP_INITIALIZER, useFactory: (settings: AppSettingsService) => () => settings.getAppSettings, deps: [AppSettingsService, Http], multi: true }
    bootstrap: [AdminComponent],//, [{ provide: AdConfig, useFactory: (settings: AppSettingsService) => () => settings.getAppSettings, deps: [AppSettingsService, Http], multi: true }]]
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AdminModule {
    constructor() {
    }
}

//var injector = Injector.resolveAndCreate([HttpModule]);
//var http = injector.get(Http);

//http.get('data.json').map(res => res.json())
//    .subscribe(data => {
//        bootstrap(ContactsList, [
//            HTTP_PROVIDERS
//        provide('config', { useValue: data })
//        ]);
//    });


// WEBPACK FOOTER //
// ./app/admin/admin.module.ts